var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"losw"},_vm._l((_vm.locales),function(locale){return _c('li',{key:locale,on:{"click":function($event){return _vm.switchLocale(locale)}}},[_c('img',{staticClass:"country-icon",attrs:{"src":_vm.icons[locale]}})])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }